import Index from '../views/VideoWall/Index'

let routes = {
    path: '/video_wall',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/video_wall',
            name: 'list-video-wall',
            component: Index,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Video Wall',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
